export type AvailableLanguage = {
  nativeName: string;
  code: string;
  name: string;
}

export const AVAILABLE_LANGUAGES: Array<AvailableLanguage> = [
  {
    nativeName: 'العربية',
    code: 'ar',
    name: 'Arabic',
  },
  {
    nativeName: 'български',
    code: 'bg',
    name: 'Bulgarian',
  },
  {
    nativeName: '中文',
    code: 'zh',
    name: 'Chinese',
  },
  {
    nativeName: 'hrvatski',
    code: 'hr',
    name: 'Croatian',
  },
  {
    nativeName: 'Čeština',
    code: 'cs',
    name: 'Czech',
  },
  {
    nativeName: 'Dansk',
    code: 'da',
    name: 'Danish',
  },
  {
    nativeName: 'Nederlands',
    code: 'nl',
    name: 'Dutch',
  },
  {
    nativeName: 'English',
    code: 'en',
    name: 'English',
  },
  {
    nativeName: 'eesti keel',
    code: 'et',
    name: 'Estonian',
  },
  {
    nativeName: 'Suomi',
    code: 'fi',
    name: 'Finnish',
  },
  {
    nativeName: 'Français',
    code: 'fr',
    name: 'French',
  },
  {
    nativeName: 'Deutsch',
    code: 'de',
    name: 'German',
  },
  {
    nativeName: 'Ελληνικά',
    code: 'el',
    name: 'Greek',
  },
  {
    nativeName: 'עברית',
    code: 'he',
    name: 'Hebrew',
  },
  {
    nativeName: 'हिंदी',
    code: 'hi',
    name: 'Hindi',
  },
  {
    nativeName: 'Magyar',
    code: 'hu',
    name: 'Hungarian',
  },
  {
    nativeName: 'Bahasa',
    code: 'id',
    name: 'Indonesian',
  },
  {
    nativeName: 'Italiano',
    code: 'it',
    name: 'Italian',
  },
  {
    nativeName: '日本語',
    code: 'ja',
    name: 'Japanese',
  },
  {
    nativeName: 'ಕನ್',
    code: 'kn',
    name: 'Kannada',
  },
  {
    nativeName: '한국어',
    code: 'ko',
    name: 'Korean',
  },
  {
    nativeName: 'lietuvių',
    code: 'lt',
    name: 'Lithuanian',
  },
  {
    nativeName: 'македонски',
    code: 'mk',
    name: 'Macedonian',
  },
  {
    nativeName: 'بهاس ملايو',
    code: 'ms',
    name: 'Malaysian',
  },
  {
    nativeName: 'Norsk',
    code: 'no',
    name: 'Norwegian',
  },
  {
    nativeName: 'polski',
    code: 'pl',
    name: 'Polish',
  },
  {
    nativeName: 'Português',
    code: 'pt',
    name: 'Portuguese',
  },
  {
    nativeName: 'Română',
    code: 'ro',
    name: 'Romanian',
  },
  {
    nativeName: 'русский',
    code: 'ru',
    name: 'Russian',
  },
  {
    nativeName: 'српски',
    code: 'sr',
    name: 'Serbian',
  },
  {
    nativeName: 'slovenský',
    code: 'sk',
    name: 'Slovak',
  },
  {
    nativeName: 'Slovenski',
    code: 'sl',
    name: 'Slovenian',
  },
  {
    nativeName: 'Español',
    code: 'es',
    name: 'Spanish',
  },
  {
    nativeName: 'Svenska',
    code: 'sv',
    name: 'Swedish',
  },
  {
    nativeName: 'Filipino',
    code: 'tl',
    name: 'Tagalog',
  },
  {
    nativeName: 'தமிழ்',
    code: 'ta',
    name: 'Tamil',
  },
  {
    nativeName: 'తెలుగు',
    code: 'te',
    name: 'Telugu',
  },
  {
    nativeName: 'ภาษาไทย',
    code: 'th',
    name: 'Thai',
  },
  {
    nativeName: 'Türkçe',
    code: 'tr',
    name: 'Turkish',
  },
  {
    nativeName: 'українська',
    code: 'uk',
    name: 'Ukrainian',
  },
  {
    nativeName: 'اردو',
    code: 'ur',
    name: 'Urdu',
  },
  {
    nativeName: 'Tiếng Việt',
    code: 'vi',
    name: 'Vietnamese',
  },
];
